import { ActionType, NetworkActionPrefix, RequestStatus, URL_PARAMETER_NAMES } from '../utils/constants';
import {
    AccessFunctionalityAddOnApi, AccessFunctionalityApi, AccessModuleApi, AccessProfileApi, AccessTypeApi, GeneralSettingsApi, LastFinancialPeriodTypeApi, MasterSearchReportApi,
    MasterSearchUserInputApi, SessionInformationApi, SystemLanguageApi, UserApi, UserCompanyAccessApi, UserFeedbackReportApi, UserInterfaceTextApi, UserLocalApi,
    UserTrackingLevelLinkApi
} from 'for-straction-service-api';
import { droppableNetworkAPIAction, entityLifecycleActionSet, networkAPIAction } from '../utils/actionCreatorsFactory';
import appID from '../api/appID';

export const voidAllData = () => ({ type: ActionType.VOID_ALL_DATA });

export const setWebSocketStatus = status => ({ type: ActionType.SET_WEB_SOCKET_STATUS, status });

export const addEntityChange = change => ({ type: ActionType.ADD_ENTITY_CHANGE, change });

export const dropEntityChange = change => ({ type: ActionType.DROP_ENTITY_CHANGE, change });

export const loadAccessProfiles = () => networkAPIAction(AccessProfileApi, 'accessProfileLoadAllGet', NetworkActionPrefix.LOAD_ACCESS_PROFILES_PREFIX);

export const loadAccessModules = () => networkAPIAction(AccessModuleApi, 'accessModuleLoadAllGet', NetworkActionPrefix.LOAD_ACCESS_MODULES_PREFIX);

export const loadAccessFunctionalities = () => networkAPIAction(AccessFunctionalityApi, 'accessFunctionalityLoadAllGet', NetworkActionPrefix.LOAD_ACCESS_FUNCTIONALITIES_PREFIX);

export const loadAllAccessFunctionalityAddOns = () => networkAPIAction(AccessFunctionalityAddOnApi, 'accessFunctionalityAddOnLoadAllGet', NetworkActionPrefix.LOAD_ALL_ACCESS_FUNCTIONALITY_ADD_ONS_PREFIX);

export const loadAccessTypes = () => networkAPIAction(AccessTypeApi, 'accessTypeLoadAllGet', NetworkActionPrefix.LOAD_ACCESS_TYPES_PREFIX);

export const loadSession = () => networkAPIAction(SessionInformationApi, 'sessionInformationLoadGet', NetworkActionPrefix.LOAD_SESSION_PREFIX);

export const setInitialStartingPoint = ({ initialStartingPoint1, workshopID, dialogID } = {}) =>
    networkAPIAction(SessionInformationApi, 'sessionInformationSetInitialStartingPointGet', NetworkActionPrefix.SET_INITIAL_STARTING_POINT_PREFIX, { initialStartingPoint1, workshopID, dialogID }, { initialStartingPoint1, workshopID, dialogID });

export const loadAllLastFinancialPeriodTypes = () => networkAPIAction(LastFinancialPeriodTypeApi, 'lastFinancialPeriodTypeLoadAllGet', NetworkActionPrefix.LOAD_ALL_LAST_FINANCIAL_PERIOD_TYPES_PREFIX);

export const loadGeneralSettings = () => networkAPIAction(GeneralSettingsApi, 'generalSettingsLoadGet', NetworkActionPrefix.LOAD_GENERAL_SETTINGS_PREFIX);

export const editGeneralSettings = (generalSettings, reloadAfterSync) => dispatch => new Promise((resolve, reject) => {
    dispatch({ type: ActionType.EDIT_GENERAL_SETTINGS, generalSettings });

    let promise = dispatch(networkAPIAction(GeneralSettingsApi, 'generalSettingsEditPut', NetworkActionPrefix.EDIT_GENERAL_SETTINGS_PREFIX, { generalSettings }, generalSettings));
    if (reloadAfterSync) {
        promise = promise.then(() => dispatch(loadGeneralSettings()));
    }

    promise.then(resolve, reject);
});

export const voidGeneralSettings = immediately => ({ type: ActionType.VOID_GENERAL_SETTINGS, immediately });

export const voidSession = () => ({ type: ActionType.VOID_SESSION });

export const {
    loadAllUsers/* /LOAD_ALL_USERS*/,
    loadUser/* (userID)/LOAD_USER*/,
    editUser/* (user, sync)/EDIT_USER*/,
    syncUser/* (user)/ADD_USER_PREFIX/EDIT_USER_PREFIX*/,
    voidAllUsers
} = entityLifecycleActionSet('User', 'USER', 'user', UserLocalApi, {
    loadAll: 'userLocalLoadAllGet',
    load: 'userLocalLoadGet',
    edit: 'userLocalEditUserIfEmailNotInUsePut',
    voidAll: true
});

export const addUser = (user, sync, skipCheck, sendInvitation) => dispatch => new Promise((resolve, reject) => {
    dispatch({ type: ActionType.ADD_USER, userID: user.ID, user });

    if (!sync) {
        resolve(user.ID);
    }
    else {
        dispatch(networkAPIAction(
            UserLocalApi,
            'userLocalAddUserIfEmailNotInUsePut',
            NetworkActionPrefix.ADD_USER_PREFIX,
            { userID: user.ID, user },
            user,
            skipCheck,
            sendInvitation
        ))
            .then(resolve, reject);
    }
});

export const validateUserPassword = password => droppableNetworkAPIAction(UserApi, 'userValidatePasswordGet', NetworkActionPrefix.VALIDATE_USER_PASSWORD_PREFIX, {}, password);

export const editCurrentUserPassword = password =>
    networkAPIAction(UserApi, 'userSetFirstPasswordGet', NetworkActionPrefix.EDIT_CURRENT_USER_PASSWORD_PREFIX, {}, password);

export const createUserLoginLink = userID =>
    networkAPIAction(new UserApi(), 'userCreateUserLoginLinkGet', NetworkActionPrefix.CREATE_USER_LOGIN_LINK_PREFIX, { userID }, userID);

export const {
    loadAllUserCompanyAccesses/* ()/LOAD_ALL_USER_COMPANY_ACCESSES*/,
    addUserCompanyAccess/* (access, sync)/ADD_USER_COMPANY_ACCESS*/,
    syncUserCompanyAccess/* (access)/ADD_USER_COMPANY_ACCESS_PREFIX/EDIT_USER_COMPANY_ACCESS_PREFIX*/,
    removeUserCompanyAccess/* (accessID)/DELETE_USER_COMPANY_ACCESS*/
} = entityLifecycleActionSet('UserCompanyAccess', 'USER_COMPANY_ACCESS', 'userCompanyAccess', UserCompanyAccessApi, {
    loadAll: 'userCompanyAccessLoadCurrentCompanyAccessesGet',
    add: true,
    delete: true
});

export const searchAndEditUserCompanyAccess = userCompanyAccess => (dispatch) => {
    dispatch({
        type: ActionType.EDIT_USER_COMPANY_ACCESS,
        userCompanyAccess,
        userCompanyAccessID: userCompanyAccess.ID
    });

    return dispatch(syncEditedUserCompanyAccess(userCompanyAccess));
};
export const syncEditedUserCompanyAccess = userCompanyAccess =>
    networkAPIAction(UserCompanyAccessApi, 'userCompanyAccessSearchAndEditCompanyAccessPut', NetworkActionPrefix.EDIT_USER_COMPANY_ACCESS_PREFIX, { userCompanyAccess, userCompanyAccessID: userCompanyAccess.ID }, userCompanyAccess);

export const dropPendingUsers = () => ({ type: ActionType.DROP_PENDING_USERS });

export const loadCurrentUserCompanyAccesses = () =>
    networkAPIAction(UserCompanyAccessApi, 'userCompanyAccessLoadCurrentUserAccessesGet', NetworkActionPrefix.LOAD_CURRENT_USER_COMPANY_ACCESSES_PREFIX);

export const setPartnerClientCompanyAccessesForUser = (companyIDs, userID) =>
    networkAPIAction(new UserCompanyAccessApi(), 'userCompanyAccessSetPartnerClientCompanyAccessesForUserPut', NetworkActionPrefix.SET_PARTNER_CLIENT_COMPANY_ACCESSES_FOR_USER_PREFIX, { companyIDs, userID }, companyIDs, userID);

export const loadMessages = () =>
    networkAPIAction(UserInterfaceTextApi, 'userInterfaceTextLoadKeysAndValuesForCurrentLanguageGet', NetworkActionPrefix.LOAD_MESSAGES_PREFIX);

export const loadSystemLanguages = () =>
    networkAPIAction(SystemLanguageApi, 'systemLanguageLoadAllGet', NetworkActionPrefix.LOAD_SYSTEM_LANGUAGES_PREFIX);

export const setLocale = (locale, defaultUrl = ROOT_PATH) => (dispatch) => {
    dispatch({ type: ActionType.LOAD_MESSAGES_PENDING, locale });

    new SessionInformationApi().sessionInformationSetLanguageGet(appID, locale, (error, _response) => {
        if (error) {
            dispatch({ type: ActionType.LOAD_MESSAGES_FAIL, error });
            dispatch({ type: ActionType.FAILED_API_RESPONSE });
        }
        else {
            window.location = defaultUrl;
        }
    });
};

export const setCompany = (companyID, defaultUrl = ROOT_PATH) => (dispatch) => {
    dispatch({ type: ActionType.LOAD_MESSAGES_PENDING, companyID });

    new UserCompanyAccessApi().userCompanyAccessChangeCurrentCompanyGet(appID, companyID, (error, _response) => {
        if (error) {
            dispatch({ type: ActionType.LOAD_MESSAGES_FAIL, error });
            dispatch({ type: ActionType.FAILED_API_RESPONSE });
        }
        else {
            window.location = defaultUrl;
        }
    });
};

export const sendUserInvitation = receiverUserID =>
    (dispatch) => {
        dispatch({
            type: ActionType.SEND_USER_INVITATION,
            receiverUserID
        });

        dispatch(networkAPIAction(UserApi, 'userSendUserInvitationGet', NetworkActionPrefix.SEND_USER_INVITATION_PREFIX, { receiverUserID }, receiverUserID));
    };

export const setDefaultLoginCompany = () => networkAPIAction(UserApi, 'userSetCurrentCompanyAsDefaultLoginCompanyGet', NetworkActionPrefix.SET_CURRECNT_COMPANY_AS_DEFAULT_LOGIN_COMPANY_PREFIX);

const sessionAPI = new SessionInformationApi(),
    noop = () => { };
export const keepAlive = () => {
    // just send some request so server would know app is still alive
    // we don't need results nor action handling
    // if session gets timed out or some other shit happens
    // it will be delivered via entity change socket
    sessionAPI.sessionInformationLoadGet(appID, noop);
    return { type: 'KEEP_ALIVE' };
};

export const sendUserFeedback = feedback =>
    networkAPIAction(UserFeedbackReportApi, 'userFeedbackReportSendPut', NetworkActionPrefix.SEND_USER_FEEDBACK_PREFIX, {}, feedback);

export const closeGlobalErrorDialog = () => ({ type: ActionType.HIDE_GLOBAL_ERROR_DIALOG });

export const loadLastMasterSearchQueries = limit =>
    networkAPIAction(MasterSearchUserInputApi, 'masterSearchUserInputLoadLastGet', NetworkActionPrefix.LOAD_LAST_MASTER_SEARCH_QUERIES_PREFIX, {}, { limit });

export const loadMasterSearchResults = value =>
    droppableNetworkAPIAction(MasterSearchReportApi, 'masterSearchReportTextSearchGet', NetworkActionPrefix.LOAD_MASTER_SEARCH_RESULTS_PREFIX, { value }, value);

export const voidMasterSearchResults = () => ({ type: ActionType.VOID_MASTER_SEARCH_RESULTS });

const userTrackingLevelLinkSet = entityLifecycleActionSet('UserTrackingLevelLink', 'USER_TRACKING_LEVEL_LINK', 'userTrackingLevelLink', UserTrackingLevelLinkApi, {
    loadAll: true,
    add: true,
    edit: true
});
export const loadAllUserTrackingLevelLinks = () => userTrackingLevelLinkSet.loadAllUserTrackingLevelLinks();
export const addUserTrackingLevelLink = (userTrackingLevelLink, sync) => userTrackingLevelLinkSet.addUserTrackingLevelLink(userTrackingLevelLink, sync);
export const editUserTrackingLevelLink = (userTrackingLevelLink, sync) => userTrackingLevelLinkSet.editUserTrackingLevelLink(userTrackingLevelLink, sync);
export const syncUserTrackingLevelLink = userTrackingLevelLink => userTrackingLevelLinkSet.syncUserTrackingLevelLink(userTrackingLevelLink);

export const changeSessionTo = userID => (dispatch) => {
    dispatch({ type: ActionType.CHANGE_SESSION_TO, status: RequestStatus.PENDING });

    new SessionInformationApi().sessionInformationChangeSessionToGet(appID, userID, (error, _response) => {
        if (error) {
            dispatch({ type: ActionType.FAILED_API_RESPONSE });
            dispatch({ type: ActionType.CHANGE_SESSION_TO, status: RequestStatus.FAILED });
        }
        else {
            window.location = ROOT_PATH; // load root page (clean cache)
        }
    });
};

export const revertSessionBack = (editedUserID, redirectionLocation = '') => (dispatch) => {
    dispatch({ type: ActionType.REVERT_SESSION_BACK, status: RequestStatus.PENDING });

    new SessionInformationApi().sessionInformationRevertSessionBackGet(appID, (error, response) => {
        if (error) {
            dispatch({ type: ActionType.FAILED_API_RESPONSE });
            dispatch({ type: ActionType.REVERT_SESSION_BACK, status: RequestStatus.FAILED });
        }
        else if (response) {
            window.location = `${redirectionLocation || '/organization/users/users'}?${URL_PARAMETER_NAMES.USER_ID}=${editedUserID}`; // load edit user page (clean cache)
        }
        else {
            dispatch({ type: ActionType.REVERT_SESSION_BACK, status: RequestStatus.FAILED });
        }
    });
};

export const changePartnerCompany = companyID => (dispatch) => {
    dispatch({ type: ActionType.CHANGE_PARTNER_COMPANY_PENDING, companyID });

    new SessionInformationApi().sessionInformationChangePartnerCompanyGet(appID, companyID, (error, _response) => {
        if (error) {
            dispatch({ type: ActionType.CHANGE_PARTNER_COMPANY_FAIL, error });
            dispatch({ type: ActionType.FAILED_API_RESPONSE });
        }
        else {
            window.location = '/partner_management';
        }
    });
};

export const failedAPIResponse = () => ({ type: ActionType.FAILED_API_RESPONSE });

export const dropDownloadedFile = fileID => ({ type: ActionType.DROP_DOWNLOADED_FILE, fileID });
